import { Playground, Props } from 'docz';
import Component from 'react-component-component';
import mattressIpsum from 'mattress-ipsum';
import { Row } from "../../../../../documentation/components/helpers";
import { Fade, Button } from "../../../../../src";
import * as React from 'react';
export default {
  Playground,
  Props,
  Component,
  mattressIpsum,
  Row,
  Fade,
  Button,
  React
};